export default "__VITE_ASSET__9fc4f7c8__"